<template>
    <div class="container-fluid content-wrapper">
        <p-card>
            <b-row cols="1" cols-md="2">
                <b-col> <strong v>Author: </strong>{{ product.author }} </b-col>
                <b-col> <strong v>Title: </strong>{{ product.title }} </b-col>
            </b-row>
            <b-row cols="1" cols-md="4">
                <b-col>
                    <strong v>New Selling Price: </strong
                    ><span v-if="product.newVariant">{{ currencyFormatter(product.newVariant.retail) }}</span>
                    <span v-else>{{ currencyFormatter(0.00) }}</span>
                </b-col>
                <b-col>
                    <strong v>Used Selling Price: </strong
                    ><span v-if="product.usedVariant">{{ currencyFormatter(product.usedVariant.retail) }}</span>
                    <span v-else>{{ currencyFormatter(0.00) }}</span>
                </b-col>
                <b-col>
                    <strong v>New Cost: </strong
                    ><span v-if="product.newVariant">{{ currencyFormatter(product.newVariant.cost) }}</span>
                    <span v-else>{{ currencyFormatter(0.00) }}</span>
                </b-col>
                <b-col>
                    <strong v>Used Cost: </strong
                    ><span v-if="product.usedVariant">{{ currencyFormatter(product.usedVariant.cost) }}</span>
                    <span v-else>{{ currencyFormatter(0.00) }}</span>
                </b-col>
            </b-row>
        </p-card>
        <p-card>
            <p-table
                :items="rentalInfo"
                :fields="rentalFields"
                :empty-text="'No rental information available'"
                :enable-row-selection="false"
                :show-record-count="false"
                :pagination="false"
                class="table-striped">
                
                <template #cell(newOrUsed)="data">
                    <div>
                        <div>New</div>
                        <div>Used</div>
                    </div>
                </template>

                <template #cell(rentalPrice)="data">
                    <div>
                        <div>{{ currencyFormatter(data.item.new.rentalPrice) }}</div>
                        <div>{{ currencyFormatter(data.item.used.rentalPrice) }}</div>
                    </div>
                </template>                

                <template #cell(rebate)="data">
                    <div>
                        <div>{{ currencyFormatter(data.item.new.rebate) }}</div>
                        <div>{{ currencyFormatter(data.item.used.rebate) }}</div>
                    </div>
                </template>

                <template #cell(replacementPrice)="data">
                    <div>
                        <div>{{ currencyFormatter(data.item.new.replacementPrice) }}</div>
                        <div>{{ currencyFormatter(data.item.used.replacementPrice) }}</div>
                    </div>
                </template>                

                <template #cell(lateFee)="data">
                    <div>
                        <div>{{ currencyFormatter(data.item.new.lateFee) }}</div>
                        <div>{{ currencyFormatter(data.item.used.lateFee) }}</div>
                    </div>
                </template>

                <template #cell(defaultLateFee)="data">
                    <div>
                        <div>{{ currencyFormatter(data.item.new.defaultLateFee) }}</div>
                        <div>{{ currencyFormatter(data.item.used.defaultLateFee) }}</div>
                    </div>
                </template>                
            </p-table>
        </p-card>
    </div>
</template>
<script>
import { currencyFormatter } from '@/components/Common/Formatters.js';
export default {
    props: {
        product: Object,
        rentalInfo: Array
    },
    data() {
        return {
            rentalFields: [
                { key: 'termName', label: 'Term' },
                { key: 'newOrUsed', label: '' },
                { key: 'lateFee', label: 'Late Fee' },
                { key: 'defaultLateFee', label: 'Default Late Fee' },
                { key: 'rebate', label: 'Rebate' },
                { key: 'rentalPrice', label: 'Rental Price' },
                { key: 'replacementPrice', label: 'Replacement Price' }
            ]
        };
    },
    computed: {
        checkPriceSource() {
            return this.rentalData.isNbcRental
                ? 'Mosaic Rental'
                : 'Store Managed';
        }
    },
    methods: {
        currencyFormatter: currencyFormatter
    }
};
</script>
